module.exports = __webpack_public_path__ + "img/bubble.0fb7d945.png";